<template>
  <slot></slot>
  <modal :id="modalId" :title="title" @shown="modalShown">

    <div v-if="error" class="form-group">
      <div class="col-sm-9 offset-sm-3">
        <span class="text-danger">{{ error }}</span>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-form-label col-sm-3">File Name:</label>
      <div class="col-sm-9">
        <p class="form-control-plaintext">
          {{ data.name }}

          <i v-if="!data.valid" class="fa fa-exclamation-triangle text-danger"
             data-toggle="tooltip" data-placement="top" data-boundary="window"
             :id="'tt' + modalId" :data-container="'#tt' + modalId"
             title="This document appears to be corrupt or empty"></i>
        </p>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-form-label col-sm-3">File Type:</label>
      <div class="col-sm-9">
        <select class="form-control" name="file_type" v-model="data.type">
          <option v-for="type in fileTypes" :value="type.id" :selected="type.id === data.type">{{ type.name }}</option>
        </select>
      </div>
    </div>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Close</button>
      <button type="button" class="btn btn-primary" @click="updateAttachment"><i class="fa fa-fw fa-upload"></i> Update</button>
    </template>
  </modal>

  <slot name="hidden"></slot>
</template>

<style scoped>
</style>

<script>

  import $ from "jquery";
  import HasModal from "../mixins/HasModal";

  /**
   *
   * Component used to edit Adjuster attachment.
   *
   * Emit:
   *  updated - event on successful attachment update; carry new attachment data as payload.
   *
   * Example:
   *
   * <adjuster-upload-edit-modal :update-url="updateUrl"
   *                             :file-types="fileTypes"
   *                             @updated="updated">
   * </adjuster-upload-edit-modal>
   *
   */

  export default {
    mixins: [HasModal],

    emits: ['updated'],

    props: {

      // id of modal form.
      modalId: {
        type: String,
        default: 'adjuster-upload-edit-modal',
      },

      // title of modal form.
      title: {
        type: String,
        default: 'Update Adjuster Attachment',
      },

      // Url for attachment update request.
      updateUrl: {
        required: true,
        type: String,
      },

      // File types array for Attachment.
      fileTypes: {
        type: Array,
        default: () => {
          return [];
        }
      },

      id: {
        type: Number,
        default: 0
      },

      name: {
        type: String,
        default: ''
      },

      type: {
        type: Number,
        default: 0
      },

      valid: {
        type: Boolean,
        default: true
      }
    },

    data() {

      return {
        data: {
          id: this.id,
          name: this.name,
          type: this.type,
          valid: this.valid,
        },
        error: '',
      };

    },
    methods: {
      setData(data) {

        if (data === undefined) data = {};

        Object.assign(this.data, data);

        this.error = '';
      },

      /**
       * Send update attachment request.
       */
      updateAttachment() {

        let _this = this;

        let params = {
          id: this.data.id,
          file_type: this.data.type,
          _token: this.$csrf_token,
          _method: 'PATCH',
        };

        this.setErrorMessage('');

        // Send attachment update request.
        axios.post(this.updateUrl, params)
          .then(function (response) {
            // Send success event to update data in parent component.
            _this.$emit('updated', response.data.data);
            // Programmatically close modal dialog.
            _this.$modal.hide(_this.modalId);
          })
          .catch(function (error) {
            if (error.response && error.response.status === 422) {
              _this.setErrorMessage(error.response.data.message);
            } else {
              _this.setErrorMessage('Failed to update attachment.');
            }
          });
      },

      /**
       * Display error message.
       * @param message
       */
      setErrorMessage(message) {
        this.error = message;
      },

      modalShown() {
        $('[data-toggle="tooltip"]').tooltip();
      },

    }
  }

</script>
